module.exports = __webpack_public_path__ + "img/grade_lv.c1b14c43.svg";